import { connect } from 'react-redux';
import { projectRouteTreeTooltipDataChanged } from '@Pages/RetroSynthesis/ProjectRoutes/actions';
import { openRouteOverviewTreeDialog } from '@Pages/RetroSynthesis/RouteTree/actions';
import { getRoutesTreeTooltip } from '@Pages/RetroSynthesis/ProjectRoutes/selectors';
import { typeOfRouteThumbnailDialog } from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsPopup';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import RouteThumbnailsTreeContainer from './RouteThumbnailsTreeContainerBase';

const mapStateToProps = (state) => ({
  treeTooltip: getRoutesTreeTooltip(state),
});

const openThumbnailDialog = (tree, routeName, routeId) =>
  updateDialog({
    id: typeOfRouteThumbnailDialog,
    typeOfRouteThumbnailDialog,
    dialogType: typeOfRouteThumbnailDialog,
    tree,
    routeName,
    routeId,
  });

const mapActionToProps = {
  openThumbnailPopup: openThumbnailDialog,
  updateTreeThumbnailDetails: projectRouteTreeTooltipDataChanged,
  openRouteOverviewTreePopup: openRouteOverviewTreeDialog,
};

export default connect(mapStateToProps, mapActionToProps)(RouteThumbnailsTreeContainer);
